export enum E_ExamTypes {
  DENTAL = "DENTAL",
  HYGIENE = "HYGIENE",
}
